import { trustPromises, trustStats } from "@/mocks/archiveEntries";

const TrustSection = () => {
  return (
    <section id="trust" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <span className="reveal inline-flex items-center gap-2 text-xs font-medium tracking-[0.24em] text-primary-600">
              <span className="h-px w-8 bg-primary-400" />
              备份承诺
            </span>
            <h2 className="reveal mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              重要内容备份齐全，回看时心里有底
            </h2>
            <p className="reveal mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              留档的价值在于长期可用。我们围绕完整性、可追溯与持续更新三件事，建立一套稳定可核对的备份机制。
            </p>

            <div className="mt-9 flex flex-col divide-y divide-background-200 border-y border-background-200">
              {trustPromises.map((item) => (
                <div key={item.title} className="reveal flex gap-5 py-6">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-2xl text-secondary-700">
                    <i className={item.icon} />
                  </span>
                  <div>
                    <h3 className="font-heading text-lg font-bold text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="reveal mt-9 grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-background-300 bg-background-200 sm:grid-cols-3">
              {trustStats.map((stat) => (
                <div key={stat.label} className="bg-background-50 px-5 py-6 text-center">
                  <div className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">
                    {stat.value}
                  </div>
                  <div className="mt-2 text-xs tracking-wide text-foreground-500 md:text-sm">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="reveal relative">
            <div className="relative h-72 w-full overflow-hidden rounded-lg border border-background-300 sm:h-96 lg:h-full lg:min-h-[560px]">
              <img
                src="https://readdy.ai/api/search-image?query=orderly%20archive%20room%20with%20tall%20shelves%20full%20of%20labelled%20folders%2C%20warm%20amber%20ceiling%20light%2C%20dark%20moody%20cinematic%20atmosphere%2C%20no%20people%2C%20deep%20shadows%20and%20strong%20depth%2C%20high%20detail&width=900&height=1180&seq=hl-trust-01&orientation=portrait"
                alt="留档档案库备份与校验场景"
                title="黑料看料 · 完整备份与完整性校验"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 rounded-md border border-background-100/20 bg-foreground-950/70 p-5 backdrop-blur-sm">
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-2xl text-foreground-950">
                    <i className="ri-verified-badge-line" />
                  </span>
                  <div>
                    <div className="font-heading text-base font-bold text-background-50">
                      第 3 次完整性校验已通过
                    </div>
                    <div className="mt-1 text-xs text-background-300">
                      全量批次逐条比对，结果一并留档
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;